module.exports = __webpack_public_path__ + "static/media/icon_person.ae2be227.svg";